import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Добавить аккаунт")

import { reactive } from "vue";

import { useAsync } from "@/use/useAsync";
import { useAuth } from "@/use/useAuth";
import { useUsers } from "@/use/useUsers";

import { TAuthCredential } from "@/types/auth";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";

import AppSidebar from "@/components/AppSidebar.vue";

import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiAppbarBack from "@/plugins/ui/components/appbar/UiAppbarBack.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiTextField from "@/components/ui/UiTextField.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiIconBtn from "@/components/ui/UiIconBtn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Accounts',
  setup(__props) {

const { authUser } = useAuth();
const { users, touchAccount, detachAccount } = useUsers();

const credential = reactive<TAuthCredential>({ login: "", pwd: "" });

const handleAddAccount = useAsync(async () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  await touchAccount(credential);
});

const handleDetachAccount = useAsync(async (id: number) => {
  await detachAccount(id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, { title: "Аккаунты" }, {
        left: _withCtx(() => [
          _createVNode(UiAppbarBack, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        _: 1
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _createVNode(UiGroup, null, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Добавить аккаунт" })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(handleAddAccount).execute()), ["prevent"]))
              }, [
                _createVNode(UiTextField, {
                  modelValue: credential.login,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((credential.login) = $event)),
                  modelModifiers: { trim: true },
                  label: "Логин (лицевой счет)"
                }, null, 8, ["modelValue"]),
                _createVNode(UiTextField, {
                  modelValue: credential.pwd,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((credential.pwd) = $event)),
                  modelModifiers: { trim: true },
                  label: "Пароль",
                  type: "password",
                  autocomplete: "new-password"
                }, null, 8, ["modelValue"]),
                _createVNode(UiBtn, {
                  loading: _unref(handleAddAccount).isPending.value,
                  disabled: _unref(handleAddAccount).isPending.value,
                  block: "",
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(users).value.length)
        ? (_openBlock(), _createBlock(UiGroup, { key: 0 }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Список аккаунтов" })
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users).value, (user) => {
                return (_openBlock(), _createBlock(UiCell, {
                  key: user.id,
                  title: `${user.surname} ${user.name} ${user.description}`,
                  description: user.school?.full_name
                }, {
                  right: _withCtx(() => [
                    (user.id !== _unref(authUser).value?.id)
                      ? (_openBlock(), _createBlock(UiIconBtn, {
                          key: 0,
                          onClick: ($event: any) => (_unref(handleDetachAccount).execute(user.id)),
                          icon: "X",
                          variant: "tertiary"
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["title", "description"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})